import {
  ACTIONS_TEXT,
  STATUS_OPTIONS,
} from 'src/app/components/shared/shared-constants';
import { Items } from 'src/app/core/models/common/items.model';
import { LocationValues, TotalRouteAdminControls } from '../route-admin.enum';

export const ColumnIds = {
  ROUTE: TotalRouteAdminControls.ROUTE,
  LBT: TotalRouteAdminControls.LBT,
  OPTIMIZE: TotalRouteAdminControls.OPTIMIZE,
  LOCATION: TotalRouteAdminControls.LOCATION_START_END,
  ADDRESS: TotalRouteAdminControls.ADDRESS_START_END,
  BREAK: TotalRouteAdminControls.BREAK,
  BREAK_TIME: 'breakTime',
  DURATION: TotalRouteAdminControls.DURATION,
  DEL_WAIT_TIME: TotalRouteAdminControls.DEL_WAIT_TIME,
  PU_WAIT_TIME: TotalRouteAdminControls.PU_WAIT_TIME,
  VEHICLE: TotalRouteAdminControls.VEHICLE,
  ACTION: 'action',
};

export const ColumnText = {
  ROUTE: $localize`Route Id`.toUpperCase(),
  LBT: $localize`LBT`.toUpperCase(),
  OPTIMIZE: $localize`Optimize`.toUpperCase(),
  LOCATION: $localize`Location Start/End`.toUpperCase(),
  ADDRESS: $localize`Address Start/End`.toUpperCase(),
  BREAK: $localize`Break`.toUpperCase(),
  BREAK_TIME: $localize`Break Time`.toUpperCase(),
  DURATION: $localize`Duration (min)`.toUpperCase(),
  DEL_WAIT_TIME: $localize`DEL Wait Time (min)`.toUpperCase(),
  PU_WAIT_TIME: $localize`PU Wait Time (min)`.toUpperCase(),
  VEHICLE: $localize`Vehicle`.toUpperCase(),
  ACTIONS: ACTIONS_TEXT,
};

export const ExcelColumns = [
  $localize`Route Id`.toUpperCase(),
  $localize`LBT`.toUpperCase(),
  $localize`Optimize`.toUpperCase(),
  $localize`Location Start/End`.toUpperCase(),
  $localize`Address Start/End`.toUpperCase(),
  $localize`Break`.toUpperCase(),
  $localize`Break Time Start`.toUpperCase(),
  $localize`Break Time End`.toUpperCase(),
  $localize`Duration (min)`.toUpperCase(),
  $localize`DEL Wait Time (min)`.toUpperCase(),
  $localize`PU Wait Time (min)`.toUpperCase(),
  $localize`Vehicle`.toUpperCase(),
];

export const DISPLAY_TEXT = {
  WELCOME_TEXT: $localize`Route Admin`,
  ALL_TEXT: 'All',
  DELETE_MODAL: {
    HEADER: $localize`Remove Route`,
    BODY: $localize`Are you sure you want to remove route?`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
  EDIT: 'edit',
  DELETE: 'delete',
};

export const EXCEL_FILE_NAME = 'route-admin-non-ido-data';

export const DEFAULT_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, selected: true },
];

export const DEFAULT_LOCATIONS: Items[] = [
  { id: LocationValues.Facility, selected: true },
  { id: LocationValues.Other, selected: true },
];
